import { AU_Region, PayClassificationAward } from './enums'

/** The AU awards the setup wizard supports (every award except the pseudo-award Custom). */
export type SupportedAuAward = Exclude<
  PayClassificationAward,
  PayClassificationAward.Custom
>

/**
 * Package id of the managed AU award Pay Adjustment Package for each supported award.
 *
 * These mirror the managed-data package GUIDs (verified identical across environments), which is
 * exactly the `id` on a fetched PackageDetail. Managed packages carry no structured award
 * identifier, so this map MUST be kept in lockstep with the managed data.
 */
export const AU_AWARD_PACKAGE_ID_BY_AWARD: Readonly<
  Record<SupportedAuAward, string>
> = {
  [PayClassificationAward.Restaurant]: '2e53e83b-faa5-48c0-3554-08de1cb6e464', // Restaurant Industry Award [MA000119]
  [PayClassificationAward.Hospitality]: '60d9a8a4-5edc-493b-2546-08de1bf91680', // Hospitality Industry (General) Award [MA000009]
  [PayClassificationAward.FastFood]: '720e420d-488c-4804-3553-08de1cb6e464', // Fast Food Industry Award [MA000003]
  [PayClassificationAward.Wine]: '44258046-e1fb-4def-3589-08de218d8742', // Wine Industry Award [MA000090]
}

/**
 * Package ids of the managed AU award Pay Adjustment Packages, used to detect whether a venue has
 * already set up an award (and therefore should NOT see the setup wizard).
 */
export const AU_AWARD_PACKAGE_IDS: ReadonlySet<string> = new Set<string>(
  Object.values(AU_AWARD_PACKAGE_ID_BY_AWARD)
)

/**
 * Package id of the managed Public Holidays Pay Adjustment Package for each AU state.
 * Same lockstep rules as {@link AU_AWARD_PACKAGE_ID_BY_AWARD}.
 */
export const AU_PUBLIC_HOLIDAY_PACKAGE_ID_BY_REGION: Readonly<
  Record<AU_Region, string>
> = {
  [AU_Region.ACT]: 'da2f1595-bbc7-485d-0e53-08ded0d59c10',
  [AU_Region.NSW]: 'f2aab9f5-057c-4a82-6cf9-08ded0d70cc1',
  [AU_Region.NT]: 'cc9039b1-bcf5-4e10-fda0-08ded0d8f936',
  [AU_Region.QLD]: 'adf32542-282d-4691-6cfb-08ded0d70cc1',
  [AU_Region.SA]: '09e7acf7-1093-46df-9dc9-08ded0d86644',
  [AU_Region.TAS]: 'c27a3b18-e0b7-494a-9dca-08ded0d86644',
  [AU_Region.VIC]: '116d2669-b0ba-47ae-6cfa-08ded0d70cc1',
  [AU_Region.WA]: '2f6bb3b6-2120-4681-0e54-08ded0d59c10',
}
